import { JamPadEvent } from '../DataModels';
import { Box, Typography } from '@mui/material';
import EventActions from './EventActions.tsx';

interface Props { event: JamPadEvent | undefined, seeFullEvent: any }
export const MobileEventPreview = ({ event, seeFullEvent } : Props) => {
    return <Box onClick={seeFullEvent} sx={{ 
                backgroundColor: "black", borderRadius: '4px', padding: '8px 10px', justifyContent: 'space-evenly',
                display: 'inline-flex', gap: '10px', flex: '0 0 auto', alignItems: 'center',
            }}>
                    <img src={event?.poster ?? undefined} alt={event?.title}
                    style={{ 
                        maxHeight: '100%', height: '34dvh', width: 'auto', display: 'block',
                        padding: '2px 0', borderRadius: '2px', outline: "2px solid black", 
                    }} />

                <Box component='div' sx={{
                    whiteSpace: "normal",
                    alignItems: 'center', justifyContent: 'space-evenly', textAlign: 'center',
                    display: 'flex', flexDirection: 'column',
                    outline: "2px solid grey", margin: "0", padding: '6px 14px', borderRadius: '8px'
                }}>
                    <Typography sx={{ color: 'white', fontWeight: 'bold', textWrap: 'nowrap' }} variant='body1'>
                        {event?.date.toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})} - { event?.date.toLocaleTimeString('en-US', {minute: '2-digit', hour: 'numeric'})}
                    </Typography>
                    
                    <Typography sx={{ color: 'white', fontVariant: 'small-caps' }} variant='body1'>
                        {event?.name}
                    </Typography>

                    <div style={{ 
                        display: 'flex', flexDirection: 'row',
                        alignItems: 'center', gap: '4px',
                    }}>
                        <Typography sx={{ outline: '2px solid lightblue', padding: '4px 8px', 
                            borderRadius: '12px', color: 'lightblue' }} variant='caption' fontWeight='bold'>
                            {event?.price === 0 ? "FREE" : "$" + event?.price} 
                        </Typography>
                        <Typography sx={{ outline: '2px solid lightblue', padding: '4px 8px', margin: '6px 4px',
                            borderRadius: '12px', color: 'lightblue', textWrap: 'nowrap',
                        }} variant='caption' fontWeight='bold'>
                            {event?.age === 0 ? "All Ages" : event?.age + "+"} 
                        </Typography>
                        <Typography sx={{ 
                            display: 'flex', flexDirection: 'column', gap: '0px',
                            alignItems: 'center',
                            outline: '2px solid lightblue', padding: '2px 8px',
                            borderRadius: '12px', color: 'lightblue', fontSize: '10px'
                        }} variant='caption' fontWeight='bold'>
                            {event?.rsvps} <span style={{ fontSize: '7px' }}>RSVPs</span>
                        </Typography>
                    </div>

                    <div style={{ overflow: 'hidden',
                        color: "white", padding: "6px", maxWidth: '200px'
                    }}>
                        <div style={{ overflow: 'auto', padding: '3px',
                            display: 'flex', gap: '10px', alignItems: 'center'
                        }}>
                            { event?.artist_names.length ?? 0 > 0 ?
                                <Typography variant='body2' fontWeight='bold' sx={{ textAlign: 'center', color: 'lightgray'}}>
                                    Artists:
                                </Typography>
                            :
                                <Typography variant='body2' fontWeight='bold' sx={{ flex: '1 0 100%', textAlign: 'center', color: 'white'}}>
                                    [ No featured creators ]
                                </Typography>
                            }
                            { event?.artist_names.map((artist, i) => {
                                return <Typography key={i} variant='body2' sx={{ 
                                    flex: '1', textWrap: 'nowrap',
                                    outline: event?.artist_ids[i] ? "2px solid blue" : "2px solid gray",
                                    borderRadius: '14px', padding: "6px 8px",
                                    background: event?.artist_ids[i] ? 'darkblue' : 'lightgray', 
                                    color: event?.artist_ids[i] ? 'white' : 'black'
                                }} onClick={(e) => {
                                    e.stopPropagation();
                                    console.log(event?.artist_names, event?.artist_ids);
                                }}>
                                    {artist}
                                </Typography>
                            })}
                        </div>
                    </div>
                    <EventActions event={event}/>
                </Box>
            </Box>
};
export default MobileEventPreview;